import React, { PureComponent } from 'react';
import gettext from 'js-utils/gettext';
import Icon from 'eventbrite_design_system/icon/Icon';
import CalendarSVG from 'eventbrite_design_system/iconography/icons/Calendar';

import './searchNoResultsSuggestionsHeader.scss';

export default class SearchNoResultsSuggestionsHeader extends PureComponent {
    render() {
        return (
            <>
                <div className="search-no-results eds-align--center">
                    <div className="eds-l-pad-all-2">
                        <Icon type={<CalendarSVG />} size="large" />
                    </div>
                    <div className="eds-l-pad-top-4 eds-text-bl eds-l-pad-bot-2">
                        {gettext('No events match your search')}
                    </div>
                    <div>
                        {gettext(
                            'Try a different location or check back later',
                        )}
                    </div>
                </div>
                <div className="search-no-results__section-divider"></div>
            </>
        );
    }
}
